import React from 'react';

const ScopeChecklist = ({ items, selected, onChange, className = '' }) => {
  const selectedSet = new Set(selected);

  const toggle = (key) => {
    if (selectedSet.has(key)) {
      onChange(selected.filter((k) => k !== key));
    } else {
      onChange([...selected, key]);
    }
  };

  const selectAll = () => onChange(items.map((i) => i.key));
  const clearAll = () => onChange([]);

  if (items.length === 0) {
    return (
      <p className={`text-sm text-slate-500 ${className}`}>
        Select a property type and cleaning type to see the scope checklist.
      </p>
    );
  }

  return (
    <div className={className}>
      <div className="flex items-center justify-between mb-2">
        <span className="text-sm font-medium">Scope of work</span>
        <div className="flex gap-3 text-xs">
          <button type="button" className="text-teal-700 hover:underline" onClick={selectAll}>
            Select all
          </button>
          <button type="button" className="text-slate-500 hover:underline" onClick={clearAll}>
            Clear all
          </button>
        </div>
      </div>
      <div className="grid sm:grid-cols-2 gap-2 border border-slate-200 rounded-lg p-3 bg-slate-50">
        {items.map((item) => (
          <label
            key={item.key}
            className="flex items-start gap-2 text-sm text-slate-700 cursor-pointer"
          >
            <input
              type="checkbox"
              className="mt-0.5 rounded border-slate-300 text-teal-700 focus:ring-teal-500"
              checked={selectedSet.has(item.key)}
              onChange={() => toggle(item.key)}
            />
            <span>{item.label}</span>
          </label>
        ))}
      </div>
      {selected.length === 0 && (
        <p className="text-xs text-amber-700 mt-2">Select at least one area to clean.</p>
      )}
    </div>
  );
};

export default ScopeChecklist;
